import verge from 'verge'

import {updateRawScroll, updateScroll, updateViewport} from './actions/pane'
import * as site from './store/site'
import * as pane from './store/pane'

// ////////
// Store //
// ////////

const getState = () => (TBT.store ? TBT.store.getState() : {})

const stateWindowIsLocked = () => site.windowIsLocked(getState())
const stateWindowScrollX = () => pane.scrollX(getState())
const stateWindowScrollY = () => pane.scrollY(getState())

// //////////////////
// Private Methods //
// //////////////////

// -- Scroll

const getScrollLeft = () => window.scrollX || window.pageXOffset || 0
const getScrollTop = () => window.scrollY || window.pageYOffset || 0

const setScrollLeft = (val) => window.scrollTo(val, stateWindowScrollY())
const setScrollTop = (val) => window.scrollTo(stateWindowScrollX(), val)

function handleScroll() {
  // don't use the public methods here; we want the raw scroll values
  const rawScrollX = getScrollLeft()
  const rawScrollY = getScrollTop()

  if (stateWindowIsLocked()) {
    TBT.store.dispatch(updateRawScroll(rawScrollX, rawScrollY))
  } else {
    TBT.store.dispatch(updateScroll(rawScrollX, rawScrollY))
  }
}

// -- Viewport

function handleResize() {
  TBT.store.dispatch(updateViewport(verge.viewportW(), verge.viewportH()))
}

// /////////////////
// Public Methods //
// /////////////////

// return what's in the store or try to set the document's scroll position
// if the screen is locked, trying to set the scroll position won't do anything
export const scrollX = (val) =>
  typeof val === 'undefined' ? stateWindowScrollX() : setScrollLeft(val)
export const scrollY = (val) =>
  typeof val === 'undefined' ? stateWindowScrollY() : setScrollTop(val)

// please don't use this unless you're absolutely sure
export const hardScroll = (x, y) => {
  window.scrollTo(x, y) // `window.scrollTo` must be wrapped in a new function to work properly
  TBT.store.dispatch(updateScroll(x, y))
}

export const isPhone = () => pane.windowIsPhone(getState())

// /////////////////
// Initialization //
// /////////////////

export function init() {
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', handleResize)
}

export function deinit() {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', handleResize)
}

export function documentReady() {
  // if we initialize immediately, an error will occur if the page was pre-scrolled
  // this is because handleScroll will execute while the state is still unavailable
  init()
  handleScroll()
  handleResize()
}
